/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_RefurbishedInputs */

const en_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refurbished`)
};

const es_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reacondicionado`)
};

const fr_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reconditionné`)
};

const de_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generalüberholt`)
};

const ja_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リファービッシュ品(整備済み品)`)
};

const zh_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`翻新`)
};

const ar_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجدد`)
};

const id_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekondisi`)
};

const it_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricondizionato`)
};

const ru_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Восстановленное`)
};

const pt_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recondicionado`)
};

const ko_val_refurbished = /** @type {(inputs: Val_RefurbishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`리퍼비시(재정비됨)`)
};

/**
* | output |
* | --- |
* | "Refurbished" |
*
* @param {Val_RefurbishedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_refurbished = /** @type {((inputs?: Val_RefurbishedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_RefurbishedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_refurbished(inputs)
	if (locale === "es") return es_val_refurbished(inputs)
	if (locale === "fr") return fr_val_refurbished(inputs)
	if (locale === "de") return de_val_refurbished(inputs)
	if (locale === "ja") return ja_val_refurbished(inputs)
	if (locale === "zh") return zh_val_refurbished(inputs)
	if (locale === "ar") return ar_val_refurbished(inputs)
	if (locale === "id") return id_val_refurbished(inputs)
	if (locale === "it") return it_val_refurbished(inputs)
	if (locale === "ru") return ru_val_refurbished(inputs)
	if (locale === "pt") return pt_val_refurbished(inputs)
	return ko_val_refurbished(inputs)
});